import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "../src/components/common/Layout";
import ProtectedRoute from "../src/components/common/ProtectedRoute";
import { LoaderProvider } from "./Context/ContextFunctions";
import JobsList from "./Pages/Jobs/JobsList";
import AttendanceList from "./Pages/Attendance/AttendanceList";
import ActiveProjects from "./components/common/Dashboard Navigation/ActiveProjects";
import PendingTasks from "./components/common/Dashboard Navigation/PendingTasks";
import TeamMembersList from "./components/common/Dashboard Navigation/TeamMembersList";
import CompletedTasks from "./components/common/Dashboard Navigation/CompletedTasks";
import OrderDues from "./components/common/Dashboard Navigation/OrderDues";
import PendingApproval from "./components/common/Dashboard Navigation/PendingApproval";
import PendingAmount from "./components/common/Dashboard Navigation/PendingAmount";
import DashboardExpenseList from "./Pages/Report/DashboardExpenseReport";
// Lazy-loaded pages
const Dashboard = lazy(() => import("./Pages/Dashboard/Dashboard"));
const Logout = lazy(() => import("./Pages/Login/Login"));
const ClientList = lazy(() => import("./Pages/Client")); //poc using index.jsx
const DutySlipList = lazy(() => import("./Pages/Duty-Slip"));
const ViewClient = lazy(() => import("./Pages/Client/ViewClient"));
const ViewStaff = lazy(() => import("./Pages/Staff/ViewStaffDetails"));
const Login = lazy(() => import("./Pages/Login/Login"));
const JobList = lazy(() => import("./Pages/Job/JobList"));
const StaffList = lazy(() => import("./Pages/Staff/StaffList"));
const SettingList = lazy(() => import("./Pages/Setting/SettingList"));
const ReportList = lazy(() => import("./Pages/Report/ReportList"));
const RepprtLedger = lazy(() => import("./Pages/Report/ClientLedger"));
const TaskViewLog = lazy(() => import("./Pages/Report/TaskViewLog"));

const AddUpdateClient = lazy(() => import("./Pages/Client/AddUpdateClient"));
const AddUpdateJob = lazy(() => import("./Pages/Job/AddUpdateJob"));
const TaskSheetList = lazy(() => import("./Pages/Job/TaskSheetList"));
const ProjectList = lazy(() => import("./Pages/Project/ProjectList"));
const NotificationList = lazy(() =>
  import("./Pages/Notification/Notification")
);
const ViewLog = lazy(() => import("./Pages/Staff/ViewLog"));
const ServiceJobType = lazy(() =>
  import("./Pages/Setting/ServiceJobType/ServiceJobTypeList")
);
const AddUpdateChecklist = lazy(() =>
  import("./Pages/Setting/Checklist/AddUpdateChecklist")
);
const SubscriptionsList = lazy(() =>
  import("./Pages/Subscriptions/SubscriptionList")
);
const Checkoutlist = lazy(() => import("./components/common/CheckOutList"));
const SubscriptionGraph = lazy(() => import("./components/common/GraphModue"));
const VisitorsList = lazy(() => import("./Pages/Visitors/VisitorsList"));
const PaperWork = lazy(() => import("./components/common/PaperWork"));
const Campaign = lazy(() => import("./Pages/Campaign/Campaign"));
const LeaveList = lazy(() => import("./Pages/LeaveManage/LeaveManagementList"));
const ProfileViewDetails = lazy(() =>
  import("./Pages/Profile/ProfileViewDetails")
);
const ActivityLogPage = lazy(() => import("./components/common/ActivityLog"));
const KnowledgeBase = lazy(() => import("./Pages/KnowledgeBase/KnowledgeBase"));
const DataBank = lazy(() => import("./Pages/DataBank/DataBank"));
const ReminderList = lazy(() => import("./Pages/Reminder/ReminderList"));
const EmailTemplateList = lazy(() =>
  import("./Pages/EmailTemplate/EmailTemplateList")
);
const TemplatePage = lazy(() =>
  import("./Pages/EmailTemplate/AddUpdateEmailTemplate")
);
const SupportList = lazy(() => import("./Pages/Support/SupportsList"));
const CampaignList = lazy(() => import("./Pages/Campaign/CampaignList"));
//configure
const DivisionalCategory = lazy(() => import("./Pages/Divisional-Category"));

//wallet
const Wallet = lazy(() => import("./Pages/Wallet"));
const CompanyPaymentLogs = lazy(() =>
  import("./Pages/Wallet/Company-payment-logs/CompanyPaymentLogsList")
);

const App = () => {
  return (
    <Router>
      <Layout>
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-screen">
              Loading...
            </div>
          }
        >
          <LoaderProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/logout" element={<Logout />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={Dashboard}
                  // moduleName="Dashboard"
                  />
                }
              />
              <Route
                path="/client"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ClientList}
                  // compareName={["Client"]}
                  />
                }
              />
              <Route
                path="/addUpdateClient"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={AddUpdateClient}
                  // compareName={["Tender"]}
                  />
                }
              />
              <Route
                path="/viewClient"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ViewClient}
                  // compareName={[""]}
                  />
                }
              />

              <Route
                path="/project"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ProjectList}
                    compareName={["Project"]}
                  />
                }
              />
              <Route
                path="/job"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={JobList}
                  // compareName={["Jobs"]}
                  />
                }
              />
              <Route
                path="/addUpdateJob"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={AddUpdateJob}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/TaskSheetList"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={TaskSheetList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/TaskViewLog"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={TaskViewLog}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/viewStaff"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ViewStaff}
                    compareName={["ActiveUser"]}
                  />
                }
              />
              <Route
                path="/viewLog"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ViewLog}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/staff"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={StaffList}
                    compareName={["Employee", "ActiveUser"]}
                  />
                }
              />
              <Route
                path="/report"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ReportList}
                    compareName={[
                      "PaymentSummaryReport",
                      "JobReport",
                      "ProjectReport",
                      "AttendanceReport",
                      "ExpenseReport",
                      "TenderStatusReport",
                      "TenderReport",
                    ]}
                  />
                }
              />
              <Route
                path="/expense-report"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={DashboardExpenseList}
                    compareName={["ExpenseReport", "TenderReport"]}
                  />
                }
              />

              <Route
                path="/ClientLedger"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={RepprtLedger}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/setting"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={SettingList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/jobs"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={JobsList}
                    compareName={["Jobs"]}
                  />
                }
              />
              <Route
                path="/attendance-list"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={AttendanceList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/active-projects-list"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ActiveProjects}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/pending-tasks"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={PendingTasks}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/team-members"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={TeamMembersList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/completed-task"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={CompletedTasks}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/order-dues"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={OrderDues}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/pending-payments"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={PendingAmount}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/pending-approval"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={PendingApproval}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/notification"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={NotificationList}
                    compareName={["Dashboard"]}
                  />
                }
              />
              <Route
                path="/service-job-type"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ServiceJobType}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/addupdateChecklist"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={AddUpdateChecklist}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/subscriptions"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={SubscriptionsList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/viewCheckInLog"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={Checkoutlist}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/Usage"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={SubscriptionGraph}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/visitors"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={VisitorsList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/paperWork"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={PaperWork}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/addUpdateCampaign"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={Campaign}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/wallet"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={Wallet}
                    compareName={[
                      "WalletReport",
                      "ExpenseReport",
                      "AdvanceSalary",
                      "Company Payment",
                    ]}
                  />
                }
              />
              <Route
                path="/wallet/view-logs"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={CompanyPaymentLogs}
                    compareName={["Company Payment"]}
                  />
                }
              />

              <Route
                path="/campaign"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={CampaignList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/LeaveManagement"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={LeaveList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/profile-details"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ProfileViewDetails}
                    compareName={[""]}
                  />
                  // <ProfileViewDetails />
                  // <ProtectedRoute
                  //   permission={true}
                  //   element={ProfileViewDetails}
                  //   compareName={[""]}
                  // />
                }
              />
              <Route
                path="/activity"
                element={
                  // <ProtectedRoute
                  //   permission={true}
                  //   element={ActivityLogPage}
                  //   compareName={["Department"]}
                  // />
                  <ActivityLogPage />
                }
              />
              <Route
                path="/knowledge-base"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={KnowledgeBase}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/data-bank"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={DataBank}
                    compareName={["Data Bank"]}
                  />
                }
              />
              <Route
                path="/reminder"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={ReminderList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/emailTemplate"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={EmailTemplateList}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/addUpdateTemplate"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={TemplatePage}
                    compareName={[""]}
                  />
                }
              />
              <Route
                path="/support"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={SupportList}
                    compareName={[""]}
                  />
                }
              />

              <Route
                path="/configure"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={DivisionalCategory}
                    compareName={[
                      "DivisionalCategory",
                      "DivisionalSubCategory",
                      "Department",
                      "Designation",
                      "Zone",
                      "Location",
                      "Job",
                      "City",
                      "RoleType",
                    ]}
                  />
                }
              />
              <Route
                path="/duty-slip"
                element={
                  <ProtectedRoute
                    permission={true}
                    element={DutySlipList}
                  // compareName={["DailyDuty", "WeeklyProgress"]}
                  />
                }
              />
            </Routes>
          </LoaderProvider>
        </Suspense>
      </Layout>
    </Router>
  );
};

export default App;
